import React from 'react';
import ReactDOM from 'react-dom';
import ProductFinder from '.';

const renderProductFinder = () => {
    const productFinder = document.getElementById('js-product-finder');

    if (!productFinder) {
        return;
    }

    const configName = productFinder.dataset.config;

    if (!configName) {
        return;
    }

    const props = {
        configName
    };

    ReactDOM.render(
        React.createElement(ProductFinder, props, null),
        productFinder
    );
};

renderProductFinder();
